import { render, staticRenderFns } from "./V2AddUserModal.vue?vue&type=template&id=48ae16f6&scoped=true&"
import script from "./V2AddUserModal.vue?vue&type=script&lang=js&"
export * from "./V2AddUserModal.vue?vue&type=script&lang=js&"
import style0 from "./V2AddUserModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./V2AddUserModal.vue?vue&type=style&index=1&id=48ae16f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ae16f6",
  null
  
)

export default component.exports